import { BaseApiClient } from "./BaseApiClient";
export const SEARCH_ENDPOINT = "/search?query={0}";
/**
 * SearchApiClient - client for looking for events and leagues BFF endpoints
 * @export
 * @class SearchApiClient
 * @extends {BaseApiClient}
 */
export class SearchApiClient extends BaseApiClient {
    /**
     * Search events and leagues by name from BFF
     * @param {query} string
     * @throws {RequiredError}
     * @memberof SearchApiClient
     */
    search(query) {
        let fetchOptions = {
            fetchOptOverride: {
                method: "GET"
            }
        };
        return this.executeRequest(SEARCH_ENDPOINT.format(query), fetchOptions);
    }
}
//# sourceMappingURL=SearchApiClient.js.map